import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

const domain = ENDPOINT_DOMAIN

export const getQrCode = () => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/odid/getQrCode`
        axios.get(url).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export const checkAuthQrCode = (authReqId) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/odid/checkAuthQrCode`
        let body = {
            "auth_req_id": authReqId
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}
export const auth = (onesId) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/odid/auth`
        let body = {
            "ones_did": onesId
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}
export const checkAuth = (authReqId) => {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/odid/checkAuth`
        let body = {
            "auth_req_id": authReqId
        }
        let header = {
            'Content-Type': 'application/json'
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}